"use client";

import { useEffect } from "react";

export function useScrollStartAtTop() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
}
